// extracted by mini-css-extract-plugin
export default {"dh-fotball-banner__match-result":"dh-fotball-banner-dh-fotball-banner__match-result","dhFotballBannerMatchResult":"dh-fotball-banner-dh-fotball-banner__match-result"};